import { locais } from "constants/common/formConstants";
import { getOptionLabel } from "./getOptionLabel";
import { danos } from "constants/forms/danos";
import { severidades } from "constants/common/formConstants";

function getComunication(data) {
    const parsedValue = data ? JSON.parse(data) : []
    let comunicacao = { Jap: 'Não', Jf: 'Não', Ji: 'Não', Jae: 'Não', Aap: 'Não', Af: 'Não', Ai: 'Não', Aae: 'Não' }

    if (parsedValue.length > 0)
        for (let value of parsedValue)
            if (comunicacao[value]) comunicacao = { ...comunicacao, [value]: "Sim" }

    return comunicacao
}

export function replace(row, users) {
    let copy = { ...row }
    const parsedValue = row.possiveisDanos ? JSON.parse(row.possiveisDanos) : []

    let group1 = []
    let group2 = []
    let group3 = []

    parsedValue?.forEach((num) => {
        if (num >= 1 && num <= 5) {
            group1.push(num);
        } else if (num >= 6 && num <= 9) {
            group2.push(num);
        } else {
            group3.push(num);
        }
    });

    const resposaveis = getOptionLabel(users, row?.responsaveis)
    const reporter = users?.find(x => x.value == row?.reportado_por)?.label
    const localReporter = locais?.find(x => x.value == row?.local_reporter)?.label
    const local = locais?.find(x => x.value == row?.local)?.label
    const humanos = getOptionLabel(danos[0]?.bubles, JSON.stringify(group1))
    const materiais = getOptionLabel(danos[1]?.bubles, JSON.stringify(group2))
    const outros = getOptionLabel(danos[2]?.bubles, JSON.stringify(group3))
    const comunicacao = getComunication(row?.comunicacao)
    const severidade = severidades.find(x => x.value == row?.severidade)?.label 

    return {
        ...copy,
        ...comunicacao,
        severidade,
        responsaveis: resposaveis,
        local_reporter: localReporter,
        local: local,
        reportado_por: reporter,
        humanos,
        materiais,
        outros
    }
}